export function logError(err: any) {
  // eslint-disable-next-line no-console
  console.error(err);
}
